import React from 'react'
import { Button, ContentCard, Flex, Text } from '@mprolab/uikit'
import MainWrapper from 'layouts/MainWrapper'
import styled, { useTheme } from 'styled-components'
import { useRouter } from 'hooks/useRouter'
import Image from 'components/CompatImage'
import useScreenSize from 'hooks/useScreenSize'
import { ArrowRight, Check } from 'react-feather'
import { useTranslation } from 'react-i18next'
import dottedBackground from '../../public/images/dottedBackgroundPattern1.webp'
import roundGradient from '../../public/images/roundGradient.webp'

const DottedBackgroundWrapper = styled(Flex)`
  position: absolute;
  top: -150px;
  left: 70px;
  width: 100%;
  height: 700px;
  z-index: -1;
  ${({ theme }) => theme.mediaQueries.tablet} {
    height: 550px;
    left: 0;
    left: 80px;
  }
`

const SuccessCheckWrapper = styled(Flex)`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #112408;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 16px 32px 0px rgba(145, 255, 0, 0.18);
  border: 1px solid ${({ theme }) => theme.colors.green};
`

const StyledTitle = styled(Text)`
  font-size: 40px;
  font-family: 'BiennaleBold';
  white-space: pre-wrap;
  line-height: normal;
  text-align: center;
  ${({ theme }) => theme.mediaQueries.tablet} {
    white-space: normal;
  }
`

const StyledDescription = styled(Text)`
  white-space: pre-wrap;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray3};
  line-height: 28px;
`

const FistGradientWrapper = styled(Flex)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: -200px;
  right: -160px;
  z-index: -1;
`

const SecondGradientWrapper = styled(Flex)`
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: -200px;
  left: -180px;
  z-index: -1;
`

const TransactioNSuccess: React.FC = () => {
  const { t } = useTranslation()
  const { colors } = useTheme()
  const { isMobile } = useScreenSize()
  const { push } = useRouter()

  return (
    <MainWrapper>
      <Flex
        fullWidth
        mt={isMobile ? '124px' : '192px'}
        mb={isMobile ? '124px' : '347px'}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <ContentCard
          fullWidth
          maxWidth="590px"
          p="48px 40px"
          flexDirection="column"
          gap="32px"
          justifyContent="center"
          alignItems="center"
          position="relative"
        >
          <SuccessCheckWrapper>
            <Check color={colors.white} size={32} />
          </SuccessCheckWrapper>
          <Flex flexDirection="column" gap="16px" justifyContent="center">
            <StyledTitle>{t('transactionSuccessView.title')}</StyledTitle>
            <StyledDescription>{t('transactionSuccessView.description')}</StyledDescription>
          </Flex>
          <Button endIcon={<ArrowRight />} onClick={() => push('/')}>
            {t('transactionSuccessView.buttonCTA')}
          </Button>
          <FistGradientWrapper>
            <Image src={roundGradient} />
          </FistGradientWrapper>
          <SecondGradientWrapper>
            <Image src={roundGradient} />
          </SecondGradientWrapper>
        </ContentCard>
      </Flex>
      <DottedBackgroundWrapper>
        <Image src={dottedBackground} objectFit="cover" loading="eager" />
      </DottedBackgroundWrapper>
    </MainWrapper>
  )
}

export default TransactioNSuccess
